const firebaseConfig = {
    apiKey: "AIzaSyCMj00KfFtuemeu68Je_-E0thM6yvx_bZM",
    authDomain: "crypto-verse99.firebaseapp.com",
    projectId: "crypto-verse99",
    storageBucket: "crypto-verse99.appspot.com",
    messagingSenderId: "128494140820",
    appId: "1:128494140820:web:493ef2d2093d8f0ea1a381"
  };

  export default firebaseConfig;